var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "scanTable" },
    [
      _c(
        "div",
        { staticClass: "feet-s mb10 fr" },
        [
          _c("UploadCmp", {
            attrs: {
              "auto-upload": true,
              "show-file-list": false,
              "is-check-file-type": true,
              "file-size": 50,
              limit: 20,
              tips: _vm.$t("basicData.SupportedFileFormats"),
              "btn-name": _vm.$t("GlobalSetObj.Upload"),
            },
            on: { change: _vm.onFileChange },
          }),
          _c(
            "el-button",
            {
              attrs: {
                disabled: !_vm.tableData.length,
                type: "primary",
                size: "small",
                icon: "el-icon-download",
              },
              on: { click: _vm.batchDownloadFile },
            },
            [_vm._v(_vm._s(_vm.$t("orderCenterCont.BulkDownload")))]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        { attrs: { data: _vm.fileList, border: "" } },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("basicData.fileName"),
              "min-width": "280",
              prop: "fileOriginalName",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("basicData.status"),
              "min-width": "100",
              prop: "status",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          scope.row.status
                            ? _vm.$t("basicData.Ineffective")
                            : _vm.$t("basicData.Effective")
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("orderDetails.UploadTime"),
              "min-width": "140",
              prop: "uploadTime",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("basicData.operate"),
              align: "center",
              width: "220",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        scope.row.status
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeVoid(0, scope)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("basicData.Effective")))]
                            )
                          : _c(
                              "el-button",
                              {
                                attrs: { type: "danger", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeVoid(1, scope)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("basicData.Ineffective")))]
                            ),
                        _c(
                          "el-button",
                          {
                            staticClass: "feet-btn",
                            attrs: { size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.previewFile(scope)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("operationCenter.Preview")))]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "feet-btn",
                            attrs: { type: "info", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.downloadFile(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Download")))]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm.showPreviewDialog
        ? _c("FilePreview", {
            attrs: {
              "file-list": _vm.currenFileList,
              "file-index": _vm.currentPreviewFile,
            },
            on: { close: _vm.closeViewer },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }